import type { Match2GoalsPanelNew } from 'src/game/minigame/match2-timestep/components/Match2GoalsPanelNew';
import type { Match2BoosterType } from 'src/replicant/match2/match2.ruleset';
import type {
  ImageScaleViewOpts,
  View,
  ViewOpts,
} from '@play-co/timestep-core/ui';
import type { Match2LevelPanel } from 'src/game/minigame/match2-timestep/components/Match2LevelPanel';
import type { Match2MovesPanelNew } from 'src/game/minigame/match2-timestep/components/Match2MovesPanelNew';
import type { Match2BoostersBarNew } from 'src/game/minigame/match2-timestep/components/Match2BoostersBarNew';
import { ThemeProvider, createThemeProvider } from '../ThemeProvider';
import { v2Theme } from './v2';
import {
  Match2ScoreProgressbarNew,
  Match2ScoreProgressbarOpts,
} from 'src/game/minigame/match2-timestep/components/Match2ScoreProgressbarNew';

/** Options for creating a particle effect */
export type ParticleEffectOpts = {
  superview: View;
  width: number;
  height: number;
  zIndex: number;
};

/** Interface for particle effects (snow, sakura, leaf) */
export interface ParticleEffect {
  start: () => void;
  stop: () => void;
}

export type MatchThemes = 'v2';
export type MatchTheme = {
  // UI components.
  getGoalsPanel: (opts: ViewOpts) => Match2GoalsPanelNew;
  getLevelPanel: (opts: ViewOpts) => Match2LevelPanel | undefined;
  getMovesPanel: (opts: ViewOpts) => Match2MovesPanelNew;
  getBoosterBar: (opts: ViewOpts) => Match2BoostersBarNew;
  getScoreProgressbar: (
    opts: Match2ScoreProgressbarOpts,
  ) => Match2ScoreProgressbarNew;

  // Styles.
  getQuitButtonStyle: () => ViewOpts;
  getPetContainerStyle: () => ImageScaleViewOpts;
  getGameYOffset: () => number;
  getPetContainerOffset: () => number;

  // Assets URLs.
  getLevelBackground: () => string;
  getBoosterIcon: (type: Match2BoosterType) => string;
  getUIAsset: (string: string) => string;
  getAssets: () => string[];

  // Effects.
  getParticleEffect: (opts: ParticleEffectOpts) => ParticleEffect | undefined;
};

let matchThemeProvider: ThemeProvider<MatchThemes, MatchTheme> | null = null;
export function matchTheme(): ThemeProvider<MatchThemes, MatchTheme> {
  if (!matchThemeProvider) {
    const themes = { v2: v2Theme };
    return createThemeProvider(themes, 'v2');
  }

  return matchThemeProvider;
}
